document.addEventListener('click', function(event) {
  var link = event.target.closest('[data-cart-remove], .cart__remove, [href*="/cart/change?"]');
  if (!link) return;

  var cartItem = link.closest('[data-cart-item], .cart-item');
  if (!cartItem) return;

  var bundleId = cartItem.getAttribute('data-trial-bundle-id') ||
    (cartItem.querySelector('[data-trial-bundle-id]')
      && cartItem.querySelector('[data-trial-bundle-id]').getAttribute('data-trial-bundle-id'));
  if (!bundleId) return;

  event.preventDefault();
  console.log('Bundle delete clicked, bundleId:', bundleId);

  fetch('/cart.js')
    .then(response => response.json())
    .then(function(cart) {
      // Find all line items in this bundle
      var itemsToRemove = cart.items.filter(function(item) {
        return item.properties &&
          item.properties._trial_bundle_id &&
          item.properties._trial_bundle_id === bundleId;
      });

      if (!itemsToRemove.length) return;

      // Remove each bundle item in sequence
      function removeNext(i) {
        if (i >= itemsToRemove.length) {
          location.reload();
          return;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: itemsToRemove[i].key, quantity: 0 })
        }).then(function() {
          // Proceed to next removal after current finishes
          removeNext(i + 1);
        });
      }
      removeNext(0);
    });
});
//Update quantity
document.addEventListener('change', function(event) {
  var input = event.target.closest('.quantity__input');
  if (!input) return;

  var cartItem = input.closest('[data-cart-item], .cart-item');
  if (!cartItem) return;

  var bundleId = cartItem.getAttribute('data-trial-bundle-id') ||
    (cartItem.querySelector('[data-trial-bundle-id]')
      && cartItem.querySelector('[data-trial-bundle-id]').getAttribute('data-trial-bundle-id'));
  var newQty = parseInt(input.value, 10);

  // Only handle if it's a bundle and a valid quantity
  if (!bundleId || isNaN(newQty) || newQty < 1) return;

  event.preventDefault();
  console.log('Bundle quantity change detected, bundleId:', bundleId, 'newQty:', newQty);

  fetch('/cart.js')
    .then(response => response.json())
    .then(function(cart) {
      // Find all items in this bundle
      var itemsToUpdate = cart.items.filter(function(item) {
        return item.properties &&
          item.properties._trial_bundle_id &&
          item.properties._trial_bundle_id === bundleId;
      });

      if (!itemsToUpdate.length) return;

      // Update each bundle item quantity in sequence
      function updateNext(i) {
        if (i >= itemsToUpdate.length) {
          location.reload();
          return;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: itemsToUpdate[i].key, quantity: newQty })
        }).then(function() {
          updateNext(i + 1);
        });
      }
      updateNext(0);
    });
});
